// extracted by mini-css-extract-plugin
module.exports = {"bp-tablet-small-viewport":"(min-width: 768px)","container":"doc-resource-info_container___cWEy","image":"doc-resource-info_image___7Ejw"};